export default __webpack_public_path__ + "static/media/Checked_In_Icon.aedc85f8.svg";